import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  TechDataTableRoot,
  HeaderCell,
  BodyCell,
} from "./TechDataTable.styles";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";

export const TechDataTable = () => {
  const { currentTranslations } = useSelectedOptions();
  const rows = [
    {
      name: currentTranslations?.contactPopUp?.techData?.table?.rowName1,
      size: "94,5×138,5×5",
      weight: "50kg",
    },
    {
      name: currentTranslations?.contactPopUp?.techData?.table?.rowName2,
      size: "137,5×211×15",
      weight: "170kg",
    },
    {
      name: currentTranslations?.contactPopUp?.techData?.table?.rowName3,
      size: "147,5×9×165",
      weight: "94kg",
    },
  ];
  return (
    <TechDataTableRoot>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: "transparent",
          border: "1px solid rgba(255,255,255,0.5)",
          overflowX: "auto",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <HeaderCell>
                {currentTranslations?.contactPopUp?.techData?.table?.header1}
              </HeaderCell>
              <HeaderCell>
                {currentTranslations?.contactPopUp?.techData?.table?.header2}
              </HeaderCell>
              <HeaderCell>
                {currentTranslations?.contactPopUp?.techData?.table?.header3}
              </HeaderCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.map((row, i) => (
              <TableRow key={i}>
                <BodyCell>{row?.name}</BodyCell>
                <BodyCell>{row?.size}</BodyCell>
                <BodyCell>{row?.weight}</BodyCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </TechDataTableRoot>
  );
};
